import { Option } from '@webapp/types/common/option';

export const TRACK_MENU_OPTIONS: Option[] = [
  { label: 'Replace Audio File', value: 'replace-file' },
  { label: 'Delete Song', value: 'delete' },
];

export const getMenuOptions = (
  disableRemove?: boolean,
  isImported?: boolean
) => {
  return TRACK_MENU_OPTIONS.filter((option) => {
    switch (option.value) {
      case 'delete':
        return !disableRemove && !isImported;
      default:
        return true;
    }
  });
};
